import { GasComponent } from './pages/gas/gas.component';
import { NewItemComponent } from './pages/new-item/new-item.component';
import { HomeComponent } from './pages/home/home.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from '@ews/users-management';
import { LoginComponent } from './login';
import { DetailsComponent } from './pages/details/details.component';
import { ProcessingSheetComponent } from './pages/processing-sheet/processing-sheet.component';
import { ProcessingDetailsComponent } from './pages/processing-details/processing-details.component';
import { QuestionnairePage } from './pages/questionnaire/questionnaire.page';
import { QuestionPhotosPage } from './pages/question-photos/question-photos.page';
import { QuestionCommentsPage } from './pages/question-comments/question-comments.component';
import { WasteRegistrationComponent } from './pages/waste-registration/waste-registration.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthenticatedGuard],
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'details/:id',
    component: DetailsComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'processing-sheet/:id',
    component: ProcessingSheetComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'processing-details/:id',
    component: ProcessingDetailsComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'waste-registration/:id',
    component: WasteRegistrationComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'newitem/:id',
    component: NewItemComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'gas/:id',
    component: GasComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'questionnaire/:customFormId/:parentObject/:id',
    component: QuestionnairePage,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'photos/:answerId/:maxNumberOfPhotos/:categoryKey/:question/:photosCount/:customFormId/:parentObject/:id',
    component: QuestionPhotosPage,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'comments/:answerId/:categoryKey/:question/:customFormId/:parentObject/:id',
    component: QuestionCommentsPage,
    canActivate: [AuthenticatedGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
